import type { TFunction } from 'i18next';
import type { EventSportType } from '../services/api';

/** Translate API and static event sport names without changing their IDs. */
export function eventSportLabel(sport: EventSportType, t: TFunction, language: string): string {
  const name = sport.name.trim();
  const key = name.toLowerCase().replace(/[^a-z0-9]+/g, '_');
  const fallback = language.startsWith('fa') ? sport.persian_name?.trim() || name : name;
  return t(`eventForm.sports.${key}`, { defaultValue: fallback });
}
